var Handlebars = require("/Users/mauricengo/styleguide-test/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "\n<div class=\"price\">\n  <span class=\"price__retail\">$"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.pdp : depth0)) != null ? stack1.price : stack1), depth0))
    + "</span>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/materials/modules/price/01-regular.html
// module id = 156
// module chunks = 0